module.exports = __webpack_public_path__ + "img/E-WEB-Goal-05.0bd4cf21.svg";